import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarAttendanceResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const attendanceQueryKey = (params: {
  periodId?: string | null
  programYearId?: string | null
  siteId?: string | null
}) => ['attendance', params] as const

export const useAttendance = () => {
  const session = useSession()
  const { attendancePeriodId: periodId, attendanceProgramYearId: programYearId, siteId } = useSugarContext()

  return useQuery({
    enabled: session.status === 'authenticated' && Boolean(periodId) && Boolean(programYearId) && Boolean(siteId),
    placeholderData: keepPreviousData,
    queryKey: attendanceQueryKey({ periodId, programYearId, siteId }),
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarAttendanceResponse>(`/api/attendance`, {
        params: {
          periodId,
          programYearId,
          siteId
        },
        signal
      })

      return data
    },
    staleTime: (query) => (query.state.data?.data?.sheet?.gateReason === 'gate_unavailable' ? 0 : ms('5m'))
  })
}
